/* Civil dates only: UTC arithmetic avoids DST shifts in personal weekly calendars. */
(function(root){
 function calendar(startDate,weekday,weeks){
  if(!/^\d{4}-\d{2}-\d{2}$/.test(startDate)||!Number.isInteger(weekday)||weekday<0||weekday>6||!Number.isInteger(weeks)||weeks<1||weeks>104)throw Error('invalid_input');
  const day=new Date(startDate+'T00:00:00.000Z');
  if(!Number.isFinite(day.getTime())||day.toISOString().slice(0,10)!==startDate||day.getUTCFullYear()<1900||day.getUTCFullYear()>2200)throw Error('invalid_input');
  day.setUTCDate(day.getUTCDate()+(weekday-day.getUTCDay()+7)%7);
  return Array.from({length:weeks},(_,i)=>{const date=new Date(day);date.setUTCDate(date.getUTCDate()+i*7);return date.toISOString().slice(0,10);});
 }
 if(typeof module==='object'&&module.exports)module.exports={calendar};
 else root.ElixProtocolDates={calendar};
})(typeof window==='object'?window:globalThis);
